module.exports = __webpack_public_path__ + "img/smile.63ea4820.svg";